module.exports = __webpack_public_path__ + "static/media/hotWaterCorrect.88a55866.png";